import { useOutletContext } from "react-router-dom";
import { FeeManager } from "@dealer-center/core-feemanager-react";
import { useCC9Flags } from "@dealer-center/core-third-party-launch-darkly";
import type { ControlcenterAPIInterfaceExternal } from "@dealer-center/ddc-pages-controlcenter-interface";
import type { decodedJwtAndPermissions } from "@dealer-center/ddc-api-user-interface";

export const DdcFeeManager = () => {
  const { userEntity, ccUserInfo } = useOutletContext<{
    ccUserInfo: ControlcenterAPIInterfaceExternal;
    userEntity: decodedJwtAndPermissions;
  }>();
  const { "fee-manager-access": isFeeManagerEnabled } = useCC9Flags();

  const tenantId = ccUserInfo?.accountId ?? "";
  const tenantUser = ccUserInfo?.userId ?? "";

  // isFeeManagerEnabled !== false is intentional: undefined (flag not yet loaded) grants access.
  // accountPermissions check intentionally denies when ccUserInfo is absent (misconfigured route).
  const hasAccess =
    tenantId.toLowerCase() !== "ddc" &&
    userEntity?.internal !== false &&
    isFeeManagerEnabled !== false &&
    ccUserInfo?.accountPermissions?.includes("INVENTORY.FEEMANAGER");

  return (
    <FeeManager
      basePath="/landing/nxlambda/feeManager"
      hasAccess={hasAccess}
      tenantId={tenantId}
      tenantType="DDC"
      tenantUser={tenantUser}
    />
  );
};
